import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  accessToken: string | null;
  name: string | null;
  email: string | null;
  userId: string | null;
}

interface AuthState {
  user: User | null;
}

const initialState: AuthState = {
  user: null,
};

const adminAuthSlice = createSlice({
  name: "adminAuth",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    clearUser(state) {
      state.user = null;
    },
  },
});

export const adminAuthSliceActions = adminAuthSlice.actions;
export default adminAuthSlice.reducer;
